import type { Maybe } from '@adornis/base/utilTypes.js';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { subscribeByID } from '@adornis/baseql/operations/mongo.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { IndexedDBBlobStore } from '@adornis/recorder/client/indexedDBStore.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { UserRole } from '@ils/static/enums.js';
import { BehaviorSubject, fromEvent, of, type Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ExamDay } from '../db/examdays.js'; // todo: Router Update
import { AnswerUploader } from './utils/AnswerUploader.js';

export const blobStore = new IndexedDBBlobStore('recordings', 'blobs');
export const answerUploader = new AnswerUploader();

export const fullscreen = new BehaviorSubject(false);
fullscreen.subscribe(on =>
  document.readyState === 'complete' && on !== (document.fullscreenElement !== null)
    ? on
      ? document.documentElement.requestFullscreen()
      : document.exitFullscreen()
    : undefined,
);

export const fullscreenChange = fromEvent(document, 'fullscreenchange').pipe(
  map(_ => {
    const isFull = !!document.fullscreenElement;
    fullscreen.next(isFull);
    return isFull;
  }),
);

export const isSidebarOpen = new BehaviorSubject<boolean>(true);
export const allowedRoleKeys = Object.keys(UserRole);

// track connection status
export const isOnline = new BehaviorSubject<boolean>(true);
BaseQLClient.isConnected().subscribe(isConnected => isOnline.next(!!isConnected));

const currentExamDaySelectionSet = {
  _id: 1,
  _class: 1,
  start: 1,
  end: 1,
  examType: 1,
  slotIDs: 1,
  location: { displayName: 1 },
} as const;
export const currentExamDay: Observable<Maybe<CurrentExamDay>> = routingState.searchParams
  .get('day') // TODO use signals
  .pipe(switchMap(day => (!day ? of(null) : subscribeByID(ExamDay, day)(currentExamDaySelectionSet))));

export type CurrentExamDay = NarrowedEntity<ExamDay, typeof currentExamDaySelectionSet>;
